import { render, staticRenderFns } from "./MyCoursesMain.vue?vue&type=template&id=3569ff37&scoped=true"
import script from "./MyCoursesMain.vue?vue&type=script&lang=js"
export * from "./MyCoursesMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3569ff37",
  null
  
)

export default component.exports